import { render } from "./analyze-nutrition.vue?vue&type=template&id=12e4d209&scoped=true"
import script from "./analyze-nutrition.vue?vue&type=script&lang=js"
export * from "./analyze-nutrition.vue?vue&type=script&lang=js"

import "./analyze-nutrition.vue?vue&type=style&index=0&id=12e4d209&lang=scss&scoped=true"

import exportComponent from "/home/forge/nuvita.net/envoyer/releases/20250616143743/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e4d209"]])

export default __exports__